import { User } from './../User';
export class NotificationSubjecttransaction{
    idTransaction:string;
    adehrent:User;
}